export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGIN_FAILED = 'LOGIN_FAILED'
export const SET_USER_MODE = 'SET_USER_MODE'
export const SET_USER = 'SET_USER'
export const LOGOUT = 'LOGOUT'
export const SET_NAVIGATION = 'SET_NAVIGATION'
export const CLEAR_DATA = "CLEAR_DATA"
export const CLEAR_ALLDATA="CLEAR_ALLDATA"

